import callApi from '../../util/apiCaller';
// Export Constants
export const ADD_OPPORTUNITIES = 'ADD_OPPORTUNITIES';
export const FETCH_OPEN_STAGES = 'FETCH_OPEN_STAGES';
export const ADD_ANALYSIS_OPPORTUNITY_LOGS = 'ADD_ANALYSIS_OPPORTUNITY_LOGS';

export function fetchOpportunities(criteria) {
  return (dispatch) => {
    const empty = {
      opportunities: [],
      accounts: {},
      geoStats: {},
      owners: {},
    };
    dispatch({
      type: ADD_OPPORTUNITIES, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'products',
      'repTypes',
      'repRegions',
      'stageHistories',
      'logHistories',
      // 'accountIndustries',
      'lineItems',
      'opportunityCompetitors',
      'accounts',
      'contactRoles',
    ];
    const { team } = criteria;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    const p = callApi(`search/outcomes?include=${included.join(',')}${teamId}`, 'POST', criteria);
    p.then(
      results => dispatch({
        type: ADD_OPPORTUNITIES, ...results, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: ADD_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}

export function resetOpportunities() {
  return (dispatch) => {
    const empty = {
      opportunities: [],
      geoStats: {},
      owners: {},
    };
    dispatch({
      type: ADD_OPPORTUNITIES, ...empty, status: null, errors: null,
    });
    return Promise.resolve();
  };
}

const hashedMapData = {
  all: null,
  masterRegions: {},
  regions: {},
};

export function fetchMapDataMasterRegions(masterRegion = null) {
  return () => {
    let result = null;
    if (masterRegion) {
      if (!hashedMapData.masterRegions[masterRegion]) {
        hashedMapData.masterRegions[masterRegion] = callApi(`map-data/${masterRegion}`, 'GET');
      }
      result = hashedMapData.masterRegions[masterRegion];
    } else {
      if (!hashedMapData.all) {
        hashedMapData.all = callApi('map-data', 'GET');
      }
      result = hashedMapData.all;
    }
    return result;
  };
}

export function fetchMapDataRegion(region) {
  return () => {
    if (!hashedMapData.regions[region]) {
      hashedMapData.regions[region] = callApi(`map-data/regions/${region}`, 'GET');
    }
    return hashedMapData.regions[region];
  };
}


export function fetchOpenStages() {
  return (dispatch) => {
    const empty = {
      stages: [],
    };
    dispatch({
      type: FETCH_OPEN_STAGES, ...empty, status: 'loading', errors: null,
    });
    const p = callApi('stages', 'GET', { is_closed: false });
    p.then(
      results => dispatch({
        type: FETCH_OPEN_STAGES, ...results, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: FETCH_OPEN_STAGES, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}

export function getOpportunityLogs(forecastId, opportunityId) {
  return (dispatch) => {
    dispatch({ type: ADD_ANALYSIS_OPPORTUNITY_LOGS, status: 'loading', opportunityId });
    const p = callApi(`search/opportunities/${opportunityId}/logs`, 'GET');
    p.then(
      (logDetails) => {
        dispatch({
          type: ADD_ANALYSIS_OPPORTUNITY_LOGS, status: 'loaded', opportunityId, logDetails,
        });
      },
      (error) => {
        dispatch({
          type: ADD_ANALYSIS_OPPORTUNITY_LOGS, status: 'error', opportunityId, error,
        });
      },
    );
    return p;
  };
}

export function loadAccountIndustries() {
  return () => {
    const p = callApi('accounts/industries', 'GET');
    return p;
  };
}